/**
 * Toca um som de notificação quando chega nova mensagem no chat.
 * Usa Web Audio API para um beep curto (não depende de arquivo externo).
 */
let audioContext = null;
let contextResumed = false;

function resumeContext() {
  if (audioContext && audioContext.state === 'suspended' && !contextResumed) {
    contextResumed = true;
    audioContext.resume();
  }
}

if (typeof window !== 'undefined') {
  ['click', 'touchstart', 'keydown'].forEach((ev) => {
    window.addEventListener(ev, resumeContext, { once: true });
  });
}

function getAudioContext() {
  if (typeof window === 'undefined') return null;
  if (!audioContext) {
    try {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return null;
    }
  }
  return audioContext;
}

export function playNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) return;
  try {
    if (ctx.state === 'suspended') {
      ctx.resume().then(() => playBeep(ctx)).catch(() => {});
      return;
    }
    playBeep(ctx);
  } catch (e) {}
}

function playBeep(ctx) {
  try {
    const now = ctx.currentTime;
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.frequency.setValueAtTime(880, now);
    oscillator.frequency.setValueAtTime(1100, now + 0.1);
    oscillator.type = 'sine';

    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(0.15, now + 0.02);
    gainNode.gain.linearRampToValueAtTime(0.1, now + 0.1);
    gainNode.gain.linearRampToValueAtTime(0, now + 0.2);

    oscillator.start(now);
    oscillator.stop(now + 0.2);
  } catch (e) {}
}
